const STATE = 'STATE'
const CITY = 'CITY'
const ZIP = 'ZIP'
const STATUS = 'status'
const ALL = 'ALL'
const NONE = 'NONE'
const tableHeadings = [
  {
    id: 'siteId',
    header: 'SITE ID',
    isLink: true
  },
  {
    id: 'systemName',
    header: 'SYSTEM NAME'
  },
  {
    id: 'virtualPowerPlant',
    header: 'VIRTUAL POWER PLANT'
  },
  {
    id: 'programName',
    header: 'PROGRAM NAME'
  },
  {
    id: 'batteryCapacity',
    header: 'BATTERY CAPACITY'
  },
  {
    id: 'southEndSystem',
    header: 'SOUNT END SYSTEM',
    tag: true
  },
  {
    id: 'status',
    header: 'STATUS'
  }
]

const availableStatuses = {
  APPLICATION_STARTED: 'Application Started',
  APPLICATION_SUBMITTED: 'Application Submitted',
  APPLICATION_REJECTED: 'Application Rejected',
  ENROLLED: 'Enrolled',
  UNENROLLED: 'Unenrolled',
}

export {
  tableHeadings,
  availableStatuses,
  STATE,
  CITY,
  ZIP,
  STATUS,
  ALL,
  NONE
}